import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const TermsPage = () => {
    const { locale } = useParams();
    const { i18n } = useTranslation();
    
    // Using getFixedT safely isolates the language for this component render 
    // without saving it to localStorage or affecting other components
    const t = i18n.getFixedT(locale || i18n.language);

    return (
        <div className="bg-gray-50 min-vh-100 font-sans d-flex flex-column">
            {/* Header */}
            <header className="py-16 bg-white border-bottom shadow-2xs">
                <div className="container container-lg d-flex align-items-center justify-content-between">
                    <Link to="/" className="d-flex align-items-center gap-12 text-decoration-none">
                        <img src="/logo192.png" alt="Catálogo App" className="w-36 h-36 object-fit-contain" />
                        <span className="fw-bold text-gray-900 text-lg d-none d-sm-block">Catálogo App</span>
                    </Link>
                    
                    <div className="d-flex align-items-center gap-16">
                        <LanguageSwitcher />
                        <Link to="/" className="btn btn-outline-main rounded-pill px-20 py-6 text-xs fw-semibold">
                            {t('terms.backToHome')}
                        </Link>
                    </div>
                </div>
            </header>

            {/* Content */}
            <div className="container container-lg py-60 flex-grow-1" style={{ maxWidth: '840px' }}>
                <div className="bg-white p-32 p-md-48 rounded-24 border shadow-sm">
                    <h2 className="fw-bold text-gray-900 mb-24 text-center">{t('terms.title')}</h2>
                    
                    <div className="d-flex flex-column gap-24 text-gray-700 text-sm lh-lg text-justify" style={{ textAlign: 'justify' }}>
                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.infoRelevant.title')}</h5>
                            <p>{t('terms.infoRelevant.p1')}</p>
                            <p>{t('terms.infoRelevant.p2')}</p>
                            <p>{t('terms.infoRelevant.p3')}</p>
                            <p>{t('terms.infoRelevant.p4')}</p>
                        </section>

                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.license.title')}</h5>
                            <p>{t('terms.license.p1')}</p>
                        </section>

                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.unauthorized.title')}</h5>
                            <p>{t('terms.unauthorized.p1')}</p>
                        </section>

                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.property.title')}</h5>
                            <p>{t('terms.property.p1')}</p>
                        </section>

                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.refund.title')}</h5>
                            <p>{t('terms.refund.p1')}</p>
                            <p>{t('terms.refund.p2')}</p>
                        </section>

                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.antifraud.title')}</h5>
                            <p>{t('terms.antifraud.p1')}</p>
                        </section>

                        <section>
                            <h5 className="fw-bold text-gray-900 mb-12 text-md">{t('terms.privacy.title')}</h5>
                            <p>{t('terms.privacy.p1')}</p>
                            <p>{t('terms.privacy.p2')}</p>
                            <p>{t('terms.privacy.p3')}</p>
                        </section>
                    </div>

                    <div className="pt-24 mt-32 border-top text-center text-xs text-gray-400">
                        {t('terms.updateText')}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsPage;
